<template>
	<div>
		<app-table
			class="mt-5 is-not-selectable"
			name="todos"
			:columns="columns"
			:current-page="currentPage"
			:last-page="lastPage"
			:rows="rows"
			@on-page="changePage"
			@on-search-event="onSearch"
		>
			<template slot="rows" slot-scope="props">
				<td class="is-not-selectable">{{ props.row.id }} </td>
				<td>{{ props.row.userId }} </td>
				<td>{{ props.row.title }} </td>
				<td>{{ props.row.completed }} </td>
				<td>
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar Cliente"
						@click-icon="edit(props.row)"
					/>
					<app-tooltip-button
						color="primary"
						icon="list_all"
						text="Generar Plan Contable"
					/>
					<app-tooltip-button
						color="red"
						icon="event"
						text="Periodos Contables"
					/>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function changePage(page) {
	this.$emit('change-page', page);
}

function edit({ id }) {
	this.goTo('page-todo-edit', { params: { id } });
}

function onSearch(value) {
	this.$emit('on-search', value);
}

export default {
	name: 'todos-list',
	components: {
		appTooltipButton,
	},
	props: {
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
	methods: {
		changePage,
		edit,
		onSearch,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/todos/todo-list.vue